<template>
  <div class="searchResults">
    <div class="searchResults--section">
      <div>
        <h3>Featured villas</h3>
        <ul v-for="(villa, index) in villas" :key="villa.id">
          <app-link
            :id="villa.id"
            type="villa"
            class="link-unstyle"
          >
            <li class="card villa--card"
                :class="{ last: index == villas.length - 1 }"
            >
              <div

                class="card__image villa lazyload"
                :style="{
                  backgroundImage: `url(${cleanImageUrl(villa.image)})`,
                }"
              />
              <div :id="villa.id" class="card__details">
                <p class="card__details--region">
                  {{ villa.region }}
                </p>
                <p class="card__details--name link-unstyle text-dark" translate="no">
                  {{ villa.name }}
                </p>

                <div class="card__details--stats">
                  <p>
                    {{ villa.guests }} Guests
                  </p>
                  <p>
                    {{ villa.beds }} Beds
                  </p>
                  <p>
                    {{ villa.bathrooms }} Bathrooms
                  </p>
                </div>
              </div>
            </li>
          </app-link>
        </ul>
      </div>

      <div class="text-center">
        <app-link id="16" type="page" class="btn-secondary-dark-sm">
          See all our villas
        </app-link>
      </div>
    </div>

    <div class="searchResults--section">
      <div>
        <h3>Featured collections</h3>
        <ul v-for="(collection, index) in collections" :key="collection.id">
          <app-link
            :id="collection.id"
            type="collection"
            class="link-unstyle"
          >
            <li class="card"
                :class="{ last: index == collections.length - 1 }"
            >
              <div

                class="card__image"
                style="background-size: cover"
                :style="{
                  backgroundImage: `url(${cleanImageUrl(collection.image)})`,
                }"
              />
              <div :id="collection.id" class="card__details">
                <p
                  class="card__details--name link-unstyle text-dark"
                >
                  {{ collection.name }}
                </p>
              </div>
            </li>
          </app-link>
        </ul>
      </div>

      <div class="text-center">
        <app-link id="1038" type="page" class="btn-secondary-dark-sm">
          See more collections
        </app-link>
      </div>
    </div>

    <div
      class="searchResults--section hide-discover"
    >
      <div>
        <h3>Discover more</h3>
        <ul>
          <!-- <li v-for="c in featuredCollection" :key="c.id" class="discover-card">
            <div class="featured">
              <div class="overlay" />
              <app-link :id="c.id" :type="c.type" class="card__image discover lazyload link-unstyle" :class="c.class" :style="getBackground(c)" :alt="c.collection">
                <p v-if="c.collection" class="text-white h3" v-html="formatHeader(c.collection)" />
                <div class="text-center">
                  <span v-if="c.cta" class="btn-underlined-light-sm">
                    {{ c.cta }}
                  </span>
                </div>
              </app-link>
            </div>
            <p>
              <a :id="c.id" :type="c.type" class="link-unstyle">
                {{ c.description }}
              </a>
            </p>
          </li> -->

          <li v-for="c in featuredCard" :key="c.id" class="discover-card">
            <div class="featured">
              <app-link :id="c.id" :type="c.type" class="card__image discover lazyload link-unstyle" :class="c.class" :style="getBackground(c)" :alt="c.collection">
                <p v-if="c.collection" class="text-white h3" v-html="formatHeader(c.collection)" />
                <div class="text-center">
                  <span v-if="c.cta" class="btn-underlined-light-sm">
                    {{ c.cta }}
                  </span>
                </div>
              </app-link>
            </div>
            <p>
              <a :id="c.id" :type="c.type" class="link-unstyle">
                {{ c.description }}
              </a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { formatHeader } from '../../../utils/formatText';
import AppLink from '../../AppLink.vue';

export default {
  name: 'Suggestions',
  components: { AppLink },
  data() {
    return {
      formatHeader,
      villas: [
        {
          name: 'Fontana',
          region: 'Palombaggia, Corsica',
          image: 'https://www.thethinkingtraveller.com/Media/Resized/Corsica%20villas/Fontana/JUL23/520/TTT_Corsica_Portovecchio_Fontana_June2023_1_4.jpg',
          guests: 8,
          beds: 4,
          bathrooms: 3,
          id: 716,
        },
        {
          name: 'Baia L’Aura',
          region: 'Marza (Ispica), Sicily',
          image: 'https://www.thethinkingtraveller.com/Media/Resized/SICILY%20villas/Baia_L_Aura/MAY22/520/TTT_Sicily_Baia_L_Aura_APR22_60.jpg',
          guests: 8,
          beds: 4,
          bathrooms: 5,
          id: 902,
        },
        {
          name: 'Alati Bay',
          region: 'Alati Bay, Paxos',
          image: 'https://www.thethinkingtraveller.com/Media/Resized/GREECE%20villas/Alatti/Selection%20for%20slideshow/520/Think_Ionian_Islands_Alati1_LR_021.jpg',
          guests: 14,
          beds: 7,
          bathrooms: 7,
          id: 707,
        },
      ],
      collections: [
        {
          name: 'Villas in Italy',
          image: 'https://www.thethinkingtraveller.com/Media/Collection%20Images/new-collections/Italy_live-la-dolce-vita_card.jpg',
          id: 934,
        },
        {
          name: 'Villas in Greece',
          image: 'https://www.thethinkingtraveller.com/Media/Collection%20Images/new-collections/luxury-villas-in-greece_card2.jpg',
          id: 878,
        },
        {
          name: 'Villas in Corsica',
          image: 'https://www.thethinkingtraveller.com/Media/Collection%20Images/new-collections/france_corsica_luxury-villas_card.jpg',
          id: 520,
        },
      ],
      featuredCollection: [
        {
          collection: 'Villas with special rates for Summer 2024',
          image: require('../../../assets/img/src/navbar/algolia/Spring_2024_collection.jpg'),
          type: 'collection',
          id: 847,
          cta: 'summer villas',
          description: 'Special rates for April and May stays',
          class: 'featured-collection',
        },
      ],

      featuredCard: [
        {
          image: require('../../../assets/img/src/navbar/algolia/culinary_retreat.jpg'),
          type: 'page',
          id: 880,
          description: 'Culinary retreats Rocca delle Tre Contrade',
        },
      ],
    };
  },
  computed: {
    // sortedVillas() {
    //   if (this.villas) {
    //     return this.villas.sort((a, b) => ((a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0)));
    //   }
    // },
  },
  created() {
    // this.fetchVillas();
  },
  methods: {
    // fetchVillas() {
    //   const arr = [];
    //   this.villaIds.forEach((id, i) => {
    //     this.$store.dispatch('properties/fetchPropertyById', id).then((res) => {
    //       arr.push({ villa: res, order: i });
    //     });
    //   });
    //   this.villas = arr;
    // },
    // getBackground(d) {
    //   return {
    //     backgroundImage: `url(https://www.thethinkingtraveller.com${d.villa.cardImageLarge.replaceAll("'", '%27')})`,
    //   };
    // },
    // getRegion(id) {
    //   return this.$store.getters['regions/getRegionNameBydId'](id);
    // },
    cleanImageUrl(url) {
      if (url) {
        url = url.replace(/\(/g, "%28"); // eslint-disable-line
        url = url.replace(/\)/g, "%29"); // eslint-disable-line
        url = url.replace(/\ /g, "%20"); // eslint-disable-line
      }
      return url;
    },
    getBackground(c) {
      return {
        backgroundImage: `url(${c.image})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/settings/_config.scss';

.searchResults {
  padding-top: 1em;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: 1fr;
  max-width: 1500px;
  margin: 0 auto;
  // @media (min-width: 1478px) {
  //   margin: 0 5em;
  // }
  // @media (min-width: 1026px) {
  //   margin: 0 1em;
  // }
  @media (min-width: 768px) and (max-width: 1025px) {
    display: block;
    margin: 1em 6em;
  }

  &--section {
    max-width: 400px;
    padding: 0 1em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    color: $darkBlack;
    font-size: 14px;
    h3 {
      font-size: 14px;
      font-weight: 500;
    }
    @media (min-width: 768px) and (max-width: 1025px) {
      max-width: 100%;
      margin-bottom: 4em;
    }
    @media (max-width: 768px) {
      margin-bottom: 4em;
    }

    .btn-secondary-dark-sm {
      width: fit-content;
      margin: 1.5em 0 10px;
    }
  }
}

.card {
  cursor: pointer;
  margin-bottom: 1em;
  display: flex;
  align-items: center;
  background: $stoneCream;
  &.last {
    margin-bottom: 0;
  }
  @media (max-width: 480px) {
    margin-bottom: 20px;
  }

  &__image {
    height: 94px;
    min-width: 94px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    &.discover {
      height: 155px;
      width: 100%;
    }

    img {
      height: 100%;
      width: 100%;
      // to keep the fallback image behind background image
      position: relative;
      z-index: -1;
    }
  }
  &__details {
    height: 94px;
    padding: 1em;
    width: 100%;
    border: 1px solid $stoneLight;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      margin: 0;
    }
    &--region {
      text-transform: uppercase;
      font-size: 10px;
    }
    &--stats {
      display: flex;
      align-items: center;
      p {
        margin-right: 15px;
        font-size: 10px;
        display: flex;
        align-items: center;
        text-transform: uppercase;
      }
    }
  }
}

.discover-card {
  cursor: pointer;
  // padding-bottom: 1.5em;
  // padding-left: 2.3em;
  a {
    padding-top: 5px;
  }
  @media (max-width: 1025px) {
    border: 0;
    padding: 0;
  }
  p {
    margin-top: 5px;
  }
  &.last {
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
}

.hide-discover {
  h3 {
    // padding-left: 2.5em;

    @media (max-width: 768px) {
      padding-left: 0;
    }
  }
  @media (min-width: 1024px) and (max-width: 1286px) {
    display: none;
  }
}

.noResults {
  ul {
    li {
      line-height: 1.8;
    }
  }
}

.ais-Hits {
 height: 100%;
}

.z-index {
  z-index: 0 !important;
}

.retreat {
  a {

    height: 222px;
  }
}
.featured {
  position: relative;
}
.discover {
  height: 222px;
  padding: 12px;
  width: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-size: cover;
  flex-shrink: initial;
  @media screen and (max-width: 480px) {
    margin: 0 0 1em 0;
    min-width: 100%;
    height: 400px;
  }
  &.featured-collection {
    height: 222px;
  }
  p.h3 {
    font-size: 20px;
    font-family: $font-family-editorial;
    text-transform: none;
    font-style: italic;
    z-index: 1;
    @media screen and (max-width: 480px) {
      font-size: 32px;
    }
  }
}
</style>
